import { registerComponent } from '@gig/magic-common';
import { default as LoyaltyTierCard } from './loyalty-tier-card.vue?shadowMode';

registerComponent(LoyaltyTierCard);
